import apiService from "./../../../../server";
import { CURRENT_USER, DASHBOARD, RECENT_ACTIVITY, USERS } from "../api";

export function dashboard() {
    return apiService.get(DASHBOARD);
}
export function fetchRecentActivity(page:any,size:any) {
    return apiService.get(RECENT_ACTIVITY,{params:{"page":page, "size":size}});
}
export function loggedInUser() {
    return apiService.get(CURRENT_USER);
}

